export enum ThemePalette {
  PRIMARY_COLOR = '#2D2D2D',
  SECONDARY_COLOR = '#FEBE19',
  PRIMARY_TEXT_COLOR = '#FEBE19',
  ERROR_COLOR = '#B00020',
}
